import { APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { BannerSearchListAPIModel } from './bannersearchlistapimodel';
//import { GetPlaylistProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/getplaylistprocessorfactory';
import { GetPlaylistResponse } from '../../../../../core/api/banner/getplaylist/getplaylistresponse';
import { GetPlaylistDtoImpl } from '../../../../../core/dto/getplaylist/getplaylistdto';
import { GetPlaylistRequestImpl } from '../../../../../core/api/banner/getplaylist/getplaylistrequest';
import { BannerProcessorFactory } from '../../../../../core/processorfactory/bannerprocessorfactory';

export class MusicboxBannerListAPIModelImpl extends APIModelImpl implements BannerSearchListAPIModel
{
    private bannerProcessor: BannerProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.bannerProcessor = this.getAPIProcesssorFactory().getBannerAPIProcessorFactory();
    }

    getListofBannerTones(order: string, type: string, searchKey: string,startIndex: number, offset: number): void
    {
        let bannerDto = new GetPlaylistDtoImpl();
        bannerDto.setType("MB");
        bannerDto.setToneCode(searchKey);
        bannerDto.setContentTypeId("2");
        bannerDto.setIsAll("T");
        bannerDto.setLanguage(this.getContext().getUserContext().getLanguage());
        bannerDto.setClientSessionId("998671752");
        
       this.bannerProcessor.getPlaylistWhenBannerTypeIsMusicBox()
                   .success((bannerResponse : GetPlaylistResponse)=>
                    {
                      this.getAPIModelHandler().onSuccess(bannerResponse.getAPIFeature(), 
                        bannerResponse.getDescription(), bannerResponse.getGetPlaylistDto());
                    })
                  .failure((bannerResponse : GetPlaylistResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(bannerResponse.getAPIFeature(), 
                      bannerResponse.getDescription(), bannerResponse);
                    })
                  .execute(new GetPlaylistRequestImpl(bannerDto));    
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/musicboxbannerlistapimodel.tsx